import React from 'react'

const Paragraph = ({ children }: { children: React.ReactNode }) => (
  <div className="font-normal text-sm text-[#5B6871] py-2">{children}</div>
)

export default Paragraph
